import React from "react";

const admissionCategories = [
  {
    title: "Incoming Freshmen",
    items: [
      "Form 138 (Original Copy) high school report card",
      "Form 137 – A (may be submitted later)",
      "Certificate of Good Moral Character",
      "NSO Authenticated Birth Certificate",
      "2 pcs recent 2 × 2 picture",
      "1 pc long brown envelope",
    ],
  },
  {
    title: "Transferees",
    items: [
      "Certificate of Transfer Credentials (CTC) or Honorable Dismissal (HD)",
      "Informative copy of Transcript of Records (TOR) for Evaluation purposes",
      "Certificate of Good Moral Character",
      "NSO Authenticated Birth Certificate",
      "2 pcs recent 2 × 2 picture",
      "1 pc long brown envelope",
    ],
    note: "Second Courser shall meet the requirement for admission of incoming freshmen.",
  },
  {
    title: "Cross Enrollees",
    note: "Permit to cross enroll from the Registrar of the mother school indicating the course, units, school year, and specific school to admit the student.",
  },
];

function Admission() {
  return (
    <div className="bg-white rounded-2xl border border-stone-200 shadow-sm overflow-hidden">
      {/* Accent top bar */}
      <div className="h-1.5 w-full bg-sky-600" />

      <div className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-1 bg-sky-600 rounded-full" />
          <h3 className="text-lg font-bold text-stone-800 tracking-tight">Admission Requirements</h3>
        </div>

        <div className="space-y-6">
          {admissionCategories.map((cat, idx) => (
            <div key={idx}>
              <span className="inline-block px-3 py-0.5 rounded-full bg-sky-50 text-sky-700 border border-sky-200 text-xs font-semibold tracking-wide uppercase mb-3">
                {cat.title}
              </span>
              {cat.items && (
                <ol className="space-y-1.5 ml-1">
                  {cat.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-stone-600">
                      <span className="mt-1 w-4 h-4 rounded-full bg-sky-100 text-sky-600 text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                        {i + 1}
                      </span>
                      {item}
                    </li>
                  ))}
                </ol>
              )}
              {cat.note && (
                <p className="mt-2 text-xs text-stone-400 italic leading-relaxed">
                  {cat.note}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Admission;
